export const hasNumber = (password) => /\d/.test(password)

export const hasUpperCase = (password) => /[A-Z]+/g.test(password)

export const hasLowerCase = (password) => /[a-z]+/g.test(password)

export const hasSpecialCharacters = (password) => /[!@#$%&]+/.test(password)